import {
    AI_SERVER_ON_MAINTENANCE_WEB_COMPONENT,
    MAINTENANCE_AI_SERVER_CURRENT_STATE,
    MAINTENANCE_AI_SERVER_OPTIONS,
} from './CONSTANTS';

/**
 * Open the AI server on maintenance modal.
 * @returns {void}
 */
export const openAIServerOnMaintenanceModal = () => {
    let /** @type {HTMLElement} */ modal = document.querySelector(
            AI_SERVER_ON_MAINTENANCE_WEB_COMPONENT,
        );

    if (!modal) {
        document.body.appendChild(
            document.createElement(AI_SERVER_ON_MAINTENANCE_WEB_COMPONENT),
        );
        modal = document.querySelector(AI_SERVER_ON_MAINTENANCE_WEB_COMPONENT);
    }

    modal.showModal();
};

/**
 * Check if the AI server is in maintenance mode. Returns true if the server is in maintenance mode.
 * @returns {boolean}
 */
export const isAIServerMaintenance = () => {
    return MAINTENANCE_AI_SERVER_CURRENT_STATE !== MAINTENANCE_AI_SERVER_OPTIONS.ONLINE;
};
